// Görünen personeli belge durumları ve geçerlilik tarihleriyle .xlsx olarak indirir
import * as XLSX from 'xlsx';
import { EMPLOYEE_DOCS } from '../../employees/constants';

const STATUS_TR = { onay: 'Onaylı', eksik: 'Eksik', suresi_doldu: 'Süresi Doldu', kapsam_disi: 'Kapsam Dışı', beklemede: 'Beklemede' };
const fmt = (v) => (v ? v.slice(0, 10).split('-').reverse().join('.') : '');

const docStatus = (emp, key) => {
  const st = emp.documents?.[key] || 'beklemede';
  if (st === 'beklemede' && !emp.document_files?.[key]) return 'Yüklenmedi';
  return STATUS_TR[st] || st;
};

export const exportEmployeesToExcel = (list, fileName = 'personel_listesi.xlsx') => {
  const rows = list.map((emp, i) => {
    const row = { 'Sıra': i + 1, 'Ad': emp.name || '', 'Soyad': emp.surname || '', 'T.C./Pasaport No': emp.tc_kimlik_no || '', 'Uyruk': emp.nationality === 'yabanci' ? 'Yabancı' : 'T.C.', 'Görevi': emp.position || '' };
    EMPLOYEE_DOCS.forEach(d => {
      row[`${d.label} - Durum`] = docStatus(emp, d.key);
      row[`${d.label} - Geçerlilik`] = fmt(emp.documents?.[`${d.key}_validity`] || emp.documents?.[`${d.key}_date`]);
    });
    return row;
  });
  const ws = XLSX.utils.json_to_sheet(rows);
  ws['!cols'] = Object.keys(rows[0] || {}).map(k => ({ wch: Math.max(10, k.length + 2) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Personel');
  XLSX.writeFile(wb, fileName);
};
